export default __webpack_public_path__ + "static/media/Icon=Employee.9eb84018.svg";